import type { Testimonial } from '../types/content';
export const stats = [['4', 'Volúmenes completos'], ['5', 'Bonos incluidos'], ['100%', 'listo para usar']];
export const testimonials: Testimonial[] = [{
  name: 'Mariana V.',
  place: 'Buenos Aires',
  quote: "Tenía mucha información sobre autocuidado, pero no sabía por dónde empezar. Ahora encuentro lo que necesito y sé qué hacer."
}, {
  name: 'Gabriela S.',
  place: 'Córdoba',
  quote: 'Lo que más me gustó es que no tengo que inventar mis propias rutinas. Si tengo 10 minutos, busco una opción y sé exactamente qué hacer.'
}, {
  name: 'Lucía P.',
  place: 'Rosario',
  quote: 'El sistema me ayudó a dejar de guardar información que nunca aplicaba. Ahora tengo todo organizado y puedo elegir según el momento.'
}];
export const extendedTestimonials: Testimonial[] = [{
  name: 'Camila R.',
  place: 'Buenos Aires',
  quote: 'Me pasaba que quería empezar una rutina, pero terminaba buscando información durante tanto tiempo que no hacía nada. Ahora directamente tengo opciones preparadas.'
}, {
  name: 'Andrea F.',
  place: 'Córdoba',
  quote: 'Lo que más valoro es poder elegir según el tiempo que tengo. Hay días en los que solamente puedo hacer una pausa corta y aun así encuentro algo para mí.'
}, {
  name: 'Valeria S.',
  place: 'Mendoza',
  quote: 'El Mapa del Autocuidado me ordenó muchísimo. Antes veía todas estas prácticas como cosas sueltas y ahora sé dónde buscar cada una.'
}, {
  name: 'Paula M.',
  place: 'Rosario',
  quote: 'Me gustó que el sistema ya venga armado. No tengo que sentarme a crear una rutina semanal ni decidir qué hacer cada día.'
}];